export default function(state={user: null}, action) {
  switch(action.type) {
    case "GET_USER":
      return {...state, user: action.payload};

    default:
      return state;
  }
}
